import Config from './global/Config.svelte';
import Auth from './auth/Auth.svelte';
import AuthForm from './auth/AuthForm.svelte';
import AuthUserCard from './auth/AuthUserCard.svelte';
import Issue from './issue/Issue.svelte';
import IssueTag from './issue/IssueTag.svelte';
import Projects from './project/Projects.svelte';
import ProjectSelect from './project/ProjectSelect.svelte';
import ProjectCard from './project/ProjectCard.svelte';
import Boards from './board/Boards.svelte';
import BoardSelect from './board/BoardSelect.svelte';
import BoardPanel from './board/BoardPanel.svelte';
import TextWrapper from './text/TextWrapper.svelte';

export default {
  Auth,
  AuthForm,
  AuthUserCard,
  Issue,
  IssueTag,
  Projects,
  ProjectSelect,
  ProjectCard,
  Boards,
  BoardSelect,
  BoardPanel,
  TextWrapper,
  Config,
}
